import { filterOptions, Option, OptionGroup } from '@/components/form/types';
import { getIconForFieldType } from '@/explore/model/utils';
import { FieldGroup, isFieldGroup } from '@/explore/pipeline/utils';
import { Field } from '@/explore/types';

import { FieldOptionTooltip } from './field-option-tooltip';

export type FieldOption = Option<string> & { field: Field };
export type FieldOptionGroup = OptionGroup<string> & { group: FieldGroup };
export type FieldSelectOption = FieldOption | FieldOptionGroup;

export const createFieldOption = (field: Field): FieldOption => {
  return {
    label: field.name,
    value: field.key,
    icon: getIconForFieldType(field.type),
    tooltip: <FieldOptionTooltip field={field} />,
    field,
  };
};

export const createFieldOptionGrouped = (
  fieldOrGroup: Field | FieldGroup,
): FieldOption | FieldOptionGroup => {
  if (isFieldGroup(fieldOrGroup)) {
    return {
      key: fieldOrGroup.key,
      label: fieldOrGroup.name ?? '',
      options: fieldOrGroup.fields.map(createFieldOption),
      group: fieldOrGroup,
    };
  }
  return createFieldOption(fieldOrGroup);
};

export interface FieldOptionTooltipProps {
  field: Field;
}

export const filterFieldOptions = (
  options: FieldSelectOption[],
  key: string,
  relation?: { key: string; modelId?: string },
) => {
  return filterOptions(
    options,
    (option: FieldOption) =>
      option.value === key &&
      (relation === undefined ||
        (option.field.relation?.key === relation.key &&
          (relation.modelId === undefined || // funnel groupings' fake relations don't have baseModelId
            option.field.relation?.baseModelId === relation.modelId))),
  );
};
